import React from 'react';

import './index.scss';

const BubbleBot = ({ message }) => {
  return (
    <div className="bot">
      <div className="bot__bubble">
        <p>{message}</p>
      </div>
    </div>
  );
};

export default BubbleBot;
